import { render, staticRenderFns } from "./chartsofaccount.vue?vue&type=template&id=4a20b8ec&"
import script from "./chartsofaccount.vue?vue&type=script&lang=js&"
export * from "./chartsofaccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports